/**
 * Utility functions
 *
 **/

custom.utils = (function () {
  function sendCustomSentryError(message = 'Error', data = {}) {
    if (typeof Sentry != 'undefined') {
      Sentry.captureMessage(message, data);
    } else {
      console.log('Custom Sentry Error found: ', message, ' Data: ', data);
    }
  }

  function getCustomProductPrices(sku = []) {
    if (!window.customer_logged_in) {
      return false;
    }
    if (sku.length > 0) {
      $.ajax({
        url: window.LoloiConfig.pricing_app + 'customer/prices',
        method: 'POST',
        async: false,
        data: {
          customer_id: window.tier_price_info.customer_id,
          product_sku: sku,
        },
        dataType: 'json',
        success: function (response) {
          const errorResponses = response.prices.filter((item) => {
            return (
              !item.price || item.price === '99999.00' || item.price === 9999900
            );
          });
          if (errorResponses && errorResponses.length) {
            sendCustomSentryError('99k Responses from Folio3 found', {
              extra: {
                data: sku,
                response: response.prices,
              },
            });
          }
          if (typeof window.variant_prices_api === 'undefined') {
            window.variant_prices_api = response.prices;
          } else {
            Array.prototype.push.apply(
              window.variant_prices_api,
              response.prices,
            );
          }
        },
        error: function (error) {
          sendCustomSentryError('Folio3 error with customer/prices', {
            extra: {
              data: sku,
              status: error.status,
              error: error.statusText,
              response: error.responseText,
            },
          });
        },
      });
    }
  }

  function getCustomProductPricesById(ids) {
    if (!window.customer_logged_in) {
      return false;
    }
    var api_response = [];
    $.ajax({
      url: window.LoloiConfig.pricing_app + 'customer/prices_by_id',
      method: 'POST',
      async: false,
      data: {
        customer_id: window.tier_price_info.customer_id,
        product_ids: ids,
      },
      dataType: 'json',
      success: function (response) {
        api_response = response.prices;
        if (typeof api_response !== 'undefined') {
          const errorResponses = api_response.filter((item) => {
            return (
              !item.price || item.price === '99999.00' || item.price === 9999900
            );
          });
          if (errorResponses && errorResponses.length) {
            sendCustomSentryError('99k Responses from Folio3 found', {
              extra: {
                data: ids,
                response: api_response,
              },
            });
          }
          if (typeof window.variant_prices_api === 'undefined') {
            window.variant_prices_api = api_response;
          } else {
            Array.prototype.push.apply(window.variant_prices_api, api_response);
          }
        } else {
          sendCustomSentryError('Undefined response from Folio3 found', {
            extra: {
              data: ids,
              response: api_response,
            },
          });
        }
      },
      error: function (error) {
        sendCustomSentryError('Folio3 error with customer/prices_by_id', {
          extra: {
            data: ids,
            status: error.status,
            error: error.statusText,
            response: error.responseText,
          },
        });
      },
    });
    return api_response;
  }

  function getVariantPriceById(id = '') {
    if (id) {
      var variant_record = [];
      if (typeof window.variant_prices_api !== 'undefined') {
        variant_record = window.variant_prices_api
          .slice()
          .filter(function (vp) {
            return vp.id == id ? vp.price : '';
          });
      }
      if (variant_record.length > 0) {
        return variant_record[0].price;
      } else {
        if (window.tier_price_info.cart !== 'undefined') {
          variant_record = window.tier_price_info.cart
            .slice()
            .filter(function (vp) {
              return vp.id == id ? vp.price : '';
            });
        }
        if (variant_record.length > 0) {
          return parseInt(variant_record[0].price) / 100;
        } else {
          // get the price from API
          variant_records = getCustomProductPricesById([id]);
          if (variant_records.length > 0) {
            variant_record = variant_records.filter(function (vp) {
              return vp.id == id ? vp.price : '';
            });
            if (variant_record.length > 0) {
              return variant_record[0].price;
            }
          }
        }
      }
    }
  }

  // Work around for OAK Rugs
  function updateOAKPrices() {
    var oak_sku = [];
    $('.no-price').each(function () {
      oak_sku.push($(this).data('sku'));
    });
    getCustomProductPrices(oak_sku);
    custom.productsInCollection.updateCollectionPrices();
  }
  function getPriceRange(val) {
    var range;
    if (!val) {
      range = '0:10';
    } else if (val >= 0 && val < 10) {
      range = '0:10';
    } else if (val >= 10 && val < 25) {
      range = '10:25';
    } else if (val >= 25 && val < 100) {
      range = calcRange(25, val);
    } else if (val >= 100 && val < 300) {
      range = calcRange(50, val);
    } else if (val >= 300 && val < 1000) {
      range = calcRange(100, val);
    } else if (val >= 1000 && val < 5000) {
      range = calcRange(500, val);
    } else if (val >= 5000) {
      range = calcRange(1000, val);
    }
    return range;
  }

  function calcRange(interval, val) {
    var start = Math.floor(val / interval) * interval;
    var end = start + interval;
    return start + ':' + end;
  }

  function getDeviceSizeName() {
    const breakpoint = {
      small: 560,
      medium: 768,
      large: 1024,
      xlarge: 1320,
    };
    const width = $(window).width();

    if (width < breakpoint.small) {
      return 'xsmall';
    } else if (width < breakpoint.medium) {
      return 'small';
    } else if (width < breakpoint.large) {
      return 'medium';
    } else if (width < breakpoint.xlarge) {
      return 'large';
    } else {
      return 'xlarge';
    }
  }

  /**
   * titleCase
   * @params {string} str - to be title cased
   */
  function titleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map((x) => {
        return typeof x[0] !== 'string' ? x : x[0].toUpperCase() + x.slice(1);
      })
      .join(' ');
  }

  /**
   * titleCaseWithExceptions
   * @params {string} str -  to be title cased
   * Titlecase sentence except minor words.
   */
  function titleCaseWithExceptions(str) {
    // list of minor words taken from http://titlecase.com/ in settings 'Text Case Exceptions'
    const minorWords = [
      'a',
      'abaft',
      'about',
      'afore',
      'after',
      'along',
      'amid',
      'among',
      'an',
      'apud',
      'as',
      'aside',
      'at',
      'atop',
      'below',
      'but',
      'by',
      'circa',
      'down',
      'for',
      'from',
      'given',
      'in',
      'into',
      'lest',
      'like',
      'mid',
      'save',
      'since',
      'than',
      'thru',
      'till',
      'times',
      'to',
      'under',
      'until',
      'unto',
      'up',
      'upon',
      'via',
      'vice',
      'with',
      'worth',
      'the',
      'and',
      'nor',
      'or',
      'yet',
      'so',
    ];

    var strLength = str.split(' ').length;

    return str
      .toLowerCase()
      .split(' ')
      .map((x, index) => {
        if (index === 0 || index === strLength - 1 || !minorWords.includes(x)) {
          if (x[0] == '(') {
            return x[0] + x[1].toUpperCase() + x.slice(2);
          }
          return x[0].toUpperCase() + x.slice(1);
        } else {
          return x;
        }
      })
      .join(' ');
  }

  /**
   * handleize
   * @params {string} str - product/collection title
   * Transform to Shopify "handle" in order to apply into url
   */
  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /**
   * shuffle
   * @params {object} a - array to be shuffled
   * Shuffle an array element inside
   */
  function shuffle(a = []) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
  }

  /**
   * monthAbbrev
   * @params {date} unformatted date
   * returns abbreviated format month name
   */
  function monthAbbrev(date = null) {
    if (!date) date = new Date();
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return months[date.getMonth()];
  }

  /**
   * monthDayYear
   * @params {date} unformatted date
   * returns Monthname day, year
   */
  function monthDayYear(date = null) {
    if (!date) date = new Date();
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return `${
      months[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`;
  }

  /**
   * chunkArray
   * @params {array} arr - array to be chunked
   * @params {int} size - maximum size for each chunk
   * Shuffle an array element inside
   */
  function chunkArray(arr, size) {
    var index = 0;
    var arrayLength = arr.length;
    var tempArray = [];

    for (index = 0; index < arrayLength; index += size) {
      myChunk = arr.slice(index, index + size);
      // Do something if you want with the group
      tempArray.push(myChunk);
    }

    return tempArray;
  }

  /**
   * displayPrice
   * @params {number} x - price
   * display Cents of product price
   */
  function displayPrice(x = null) {
    if (!x) return;
    return `$${x.toFixed(2)}`;
  }

  // Method to format pricing
  function formatPricing(x = null) {
    // Method to return hundredths
    function getHundredths(x = null) {
      if (!x) return;
      return x / 100;
    }
    if (!x) return;
    x = getHundredths(x);
    return `$${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }

  function mobileAndTabletcheck() {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a,
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4),
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }

  async function asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  const imgUrlWithResolution = (imgUrl = '', baseRes = 300) => {
    if (!imgUrl) return null;
    const extPos = imgUrl.indexOf('.jpg');
    const hasResInUrl = imgUrl[extPos - 1] === 'x';

    if (!hasResInUrl) {
      return `${imgUrl.substr(0, extPos)}_${baseRes}x${imgUrl.substr(extPos)}`;
      // return `${imgUrl.substr(0, extPos)}_${baseRes}x${imgUrl.substr(extPos)}|${imgUrl.substr(0, extPos)}_${baseRes*2}x${imgUrl.substr(extPos)}`;
    } else {
      return `${imgUrl.substr(
        0,
        imgUrl.lastIndexOf('_'),
      )}_${baseRes}x${imgUrl.substr(extPos)}`;
      // return `${imgUrl.substr(0, imgUrl.lastIndexOf("_"))}_${baseRes}x${imgUrl.substr(extPos)}|${imgUrl.substr(0, imgUrl.lastIndexOf("_"))}_${baseRes*2}x${imgUrl.substr(extPos)}`;
    }
  };

  /**
   * scrollTo
   * @params {object} el - DOM element to scroll to
   * When re:rendering happens, this method takes user
   * to the top of search result.
   */
  const scrollTo = (el = null, offset = 0) => {
    const controller = new ScrollMagic.Controller();
    controller.scrollTo(function (newScrollPos) {
      $('html, body').animate({ scrollTop: newScrollPos }, 500, 'linear');
    });
    controller.scrollTo($(el).offset().top - offset);
  };

  /**
   * getSpecificProductImage
   *
   * @param {string} imgUrl - product original image url
   * - convert url string to smaller image url
   */
  const getSpecificProductImage = (imgUrl = '', resolution = 300) => {
    return imgUrlWithResolution(imgUrl, resolution);
  };

  /**
   * getSmallerProductImage
   *
   * @param {string} imgUrl - product original image url
   * - convert url string to smaller image url
   */
  const getSmallerProductImage = (imgUrl = '') => {
    return imgUrlWithResolution(imgUrl, 300);
  };

  /**
   * getMediumProductImage
   *
   * @param {string} imgUrl - product original image url
   * - convert url string to smaller image url
   */
  const getMediumProductImage = (imgUrl = '') => {
    return imgUrlWithResolution(imgUrl, 600);
  };

  /**
   * getCollectionThumbnailImage
   *
   * @param {string} imgUrl - product original image url
   * - convert url string to smaller image url
   */
  const getCollectionThumbnailImage = (imgUrl = '') => {
    const isMobile = mobileAndTabletcheck();
    return isMobile
      ? imgUrlWithResolution(imgUrl, 250)
      : imgUrlWithResolution(imgUrl, 65);
  };

  /**
   * initCountryProvinceSelector
   *
   * @param {string} className - Country Dropdown class
   * - Initialize each edit form's country/province selector
   * https://gist.github.com/montalvomiguelo/9cda21982732c4ebbce4804ff189e8be - shopify_common.js
   */
  const initCountryProvinceSelector = (
    className = 'address-country-option',
  ) => {
    if (!$(`.${className}`).length || !Shopify.CountryProvinceSelector) return;
    $(`.${className}`).each(function () {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      //if a country is selected
      if ($('#' + countrySelector).val() != null) {
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector,
        });
      }
    });
  };

  /**
   * parsleyOption
   *
   * NOTE: This just adds custom validator with window.ParsleyValidator.addValidator
   * - email exists on Shopify or not
   */
  function parsleyOption() {
    return {
      classHandler: function (el) {
        return (
          el.$element.closest('.custom-input') |
          el.$element.closest('.custom-checkbox')
        );
      },
    };
  }

  /**
   * getCookie
   *
   * NOTE: Returns a cookie with the specified name
   */
  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length == 2) return parts.pop().split(';').shift();
  }
  /**

  /**
   * parsleyCustomValidator
   *
   * NOTE: This just adds custom validator with window.ParsleyValidator.addValidator
   * - email exists on Shopify or not
   */
  const parsleyCustomValidator = () => {
    if (window.MUAPP || window.MUAPP.customerExists) {
      window.Parsley.addValidator('shopifyCustomerExists', {
        validateString: function (value) {
          let res = window.MUAPP.customerExists(value, () => {}, false);
          return !res.responseJSON.shopify_customer;
        },
        messages: {
          en: 'This username is already taken.',
        },
      });
    }
    window.Parsley.addValidator('validZipPostal', {
      requirementType: 'string',
      validateString: function (postalCode, requirement) {
        if (!postalCode) {
          return false;
        }
        postalCode = postalCode.toString().trim();
        const requirements = requirement.split(',');
        if (requirements.indexOf('us') >= 0) {
          const us = new RegExp('^\\d{5}(-{0,1}\\d{4})?$');
          if (us.test(postalCode.toString())) {
            return true;
          }
        }
        if (requirements.indexOf('can') >= 0) {
          const ca = new RegExp(
            /([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i,
          );
          if (ca.test(postalCode.toString().replace(/\W+/g, ''))) {
            return true;
          }
        }
        return false;
      },
      messages: {
        en: 'This needs to be a valid US zip code or Canadian postal code',
      },
    });
    window.Parsley.addValidator('fileextension', function (value, requirement) {
      let fileExt = value.split('.').pop().toLowerCase();
      return $.inArray(fileExt, requirement.split(',')) >= 0;
    }).addMessage('en', 'fileextension', 'File type is not allowed.');
    window.Parsley.addValidator('pobox', function (value, requirement) {
      var pattern = new RegExp('(P.O.|PO|Box)+\\s?.*\\d+', 'i');
      return value.match(pattern) == requirement;
    }).addMessage('en', 'pobox', 'PO Box addresses are not allowed.');
  };

  /**
   * debounce
   *
   * Standalone debounce function for events like scroll, mousemoves.
   * https://davidwalsh.name/javascript-debounce-function
   */
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Returns a function, that, as long as it continues to be invoked, will only
  // trigger every N milliseconds. If <code>immediate</code> is passed, trigger the
  // function on the leading edge, instead of the trailing.
  function throttle(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  /**
   * submitLoaderHandler
   *
   * Injects submission loader on submit
   */
  function submitLoaderHandler(input, pageTransition = false) {
    if (pageTransition) {
      const ua = window.navigator.userAgent.toLowerCase();
      const iOS = !!ua.match(/ipad/i) || !!ua.match(/iphone/i);
      const webkit = !!ua.match(/webkit/i);
      const desktopSafari =
        webkit && ua.indexOf('safari') != -1 && ua.indexOf('chrome') < 0;
      const iOSSafari = iOS && webkit && !ua.match(/crios/i);
      if (webkit && (iOSSafari || desktopSafari)) {
        // Alternative button required for transition on mobile or desktop safari. Currently animation won't work for page transition.
        input
          .prop('disabled', true)
          .addClass('js-loading btn--animated')
          .html(
            `Loading <span class="ellipsis"><span class="dot dot1">.</span><span class="dot dot2">.</span><span class="dot dot3">.</span></span>`,
          );
        return true;
      }
    }
    input
      .prop('disabled', true)
      .addClass('js-loading btn--animated')
      .html(
        `<span class="ellipsis2"><span class="dot dot1"> </span><span class="dot dot2"> </span><span class="dot dot3"> </span></span>`,
      );
  }

  /**
   * removeSubmitLoaderHandler
   *
   * Inverse case of submitLoaderHandler
   */
  function removeSubmitLoaderHandler(input, buttonText = 'Submit') {
    input
      .prop('disabled', false)
      .removeClass('js-loading btn--animated')
      .html(buttonText);
  }

  /**
   * enableOption
   *
   * Show div, then enable inputs/selects within it
   */
  function enableOption(className = null, optional = []) {
    $(className)
      .show()
      .find('input')
      .removeAttr('disabled')
      .prop('required', true)
      .end()
      .find('select')
      .removeAttr('disabled')
      .prop('required', true);
    if (optional.length > 0) {
      optional.forEach((element) => {
        $(className).find(element).prop('required', false);
      });
    }
  }

  /**
   * disableOption
   *
   * Hide div, then disable inputs/selects within it
   */
  function disableOption(className = null) {
    $(className)
      .hide()
      .find('input')
      .prop('disabled', true)
      .prop('required', false)
      .end()
      .find('select')
      .prop('disabled', true)
      .prop('required', false);
  }

  return {
    titleCase,
    titleCaseWithExceptions,
    getDeviceSizeName,
    getVariantPriceById,
    getPriceRange,
    handleize,
    shuffle,
    chunkArray,
    monthAbbrev,
    monthDayYear,
    displayPrice,
    getCustomProductPrices,
    updateOAKPrices,
    formatPricing,
    parsleyOption,
    parsleyCustomValidator,
    mobileAndTabletcheck,
    imgUrlWithResolution,
    scrollTo,
    getSpecificProductImage,
    getSmallerProductImage,
    getMediumProductImage,
    getCollectionThumbnailImage,
    initCountryProvinceSelector,
    getCookie,
    asyncForEach,
    debounce,
    throttle,
    submitLoaderHandler,
    removeSubmitLoaderHandler,
    sendCustomSentryError,
    enableOption,
    disableOption,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/utils.js